import Modalheader from "../../../components/header";
import React, { useEffect, useState } from "react";
import ModalFooter from "../../../components/footer";
import Button from "../../../../button";
import useModal from "../../../useModal";
import ModalBody from "../../../components/body";
import SelectPhone from "../../../../phone/SelectPhone";
import UseContext from "../../../../../hooks/useContext";
import ApiDatabase from "../../../../../server";

const isMissingPhone = (p) =>
  p == null ||
  p === "" ||
  p === 0 ||
  p === "0" ||
  (typeof p === "string" && p.trim() === "");

const ModalEditTempWorkerPhone = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const [phone, setPhone] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const isAddMode = isMissingPhone(modalData?.phone);

  useEffect(() => {
    setPhone(modalData.phone);
  }, [modalData]);

  const handleSubmit = () => {
    setIsLoading(true);
    ApiDatabase.updateTempWorkerPhone(
      { idTempWorker: modalData.idTempWorker, phone },
      (data) => {
        toggle();
        setIsLoading(false);
        setModalDataReturn({ phone, idTempWorker: modalData.idTempWorker });
      },
      (err) => {
        setIsLoading(false);
        console.log(err);
      },
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        {isAddMode ? "Ajouter un numéro" : "Modifier un numéro"}
      </Modalheader>
      <ModalBody>
        <div className={"flex flex-col gap-2"}>
          <div className={"text-gray-500"}>
            {isAddMode ? (
              <>
                Indiquez le numéro de téléphone de l&apos;employé. Une fois le
                numéro enregistré, l&apos;employé recevra un code PIN.
              </>
            ) : (
              <>
                Indiquez le nouveau numéro de téléphone de l&apos;employé. Une
                fois que le numéro sera modifié, l&apos;employé recevra un
                nouveau code PIN.
              </>
            )}
          </div>
          <label>
            <div className={"ft-sm font-medium text-gray-500"}>Numéro</div>
            <div className="relative">
              <SelectPhone phoneValue={phone} setPhoneValue={setPhone} />
            </div>
          </label>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button size={"LG"} color={"SECONDARY"} onClick={toggle}>
          Annuler
        </Button>
        {isLoading ? (
          <Button size={"LG"} color={"DISABLED"}>
            Confirmation...
          </Button>
        ) : (
          <Button size={"LG"} onClick={handleSubmit}>
            Confirmer
          </Button>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalEditTempWorkerPhone;
